<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0001 1.66669C5.39771 1.66669 1.66675 5.39765 1.66675 10C1.66675 14.6024 5.39771 18.3334 10.0001 18.3334C14.6025 18.3334 18.3334 14.6024 18.3334 10C18.3285 5.39971 14.6004 1.6716 10.0001 1.66669ZM10.0001 17.1429C6.05518 17.1429 2.85721 13.9449 2.85721 10C2.85721 6.05512 6.05518 2.85715 10.0001 2.85715C13.945 2.85715 17.1429 6.05512 17.1429 10C17.1387 13.9432 13.9432 17.1386 10.0001 17.1429Z"
      fill="white"
      fill-opacity="0.4"
    />
    <path
      d="M9.99976 1.5163C14.6828 1.5213 18.4781 5.31674 18.4832 9.99969C18.4832 14.6849 14.685 18.4831 9.99976 18.4831C5.31469 18.4829 1.51636 14.6848 1.51636 9.99969C1.51653 5.31474 5.3148 1.51647 9.99976 1.5163ZM9.99976 3.00751C6.13796 3.00768 3.00774 6.1379 3.00757 9.99969C3.00757 13.8616 6.13785 16.9927 9.99976 16.9929C13.8602 16.9887 16.9888 13.8601 16.9929 9.99969C16.9927 6.13779 13.8617 3.00751 9.99976 3.00751Z"
      stroke="white"
      stroke-opacity="0.4"
      stroke-width="0.3"
    />
    <path
      d="M7.02396 10.0004C7.68144 10.0004 8.21443 9.46739 8.21443 8.80991C8.21443 8.15244 7.68144 7.61945 7.02396 7.61945C6.36649 7.61945 5.8335 8.15244 5.8335 8.80991C5.8335 9.46739 6.36649 10.0004 7.02396 10.0004Z"
      fill="white"
      fill-opacity="0.4"
    />
    <path
      d="M7.02393 7.46906C7.76423 7.46906 8.36473 8.06957 8.36475 8.80988C8.36475 9.55019 7.76425 10.1507 7.02393 10.1507C6.28362 10.1507 5.68311 9.55018 5.68311 8.80988C5.68313 8.06959 6.28364 7.46908 7.02393 7.46906Z"
      stroke="white"
      stroke-opacity="0.4"
      stroke-width="0.3"
    />
    <path
      d="M12.9771 10.0004C13.6346 10.0004 14.1676 9.46739 14.1676 8.80991C14.1676 8.15244 13.6346 7.61945 12.9771 7.61945C12.3196 7.61945 11.7866 8.15244 11.7866 8.80991C11.7866 9.46739 12.3196 10.0004 12.9771 10.0004Z"
      fill="white"
      fill-opacity="0.4"
    />
    <path
      d="M12.9771 7.46906C13.7174 7.46906 14.3179 8.06957 14.3179 8.80988C14.3179 9.55019 13.7174 10.1507 12.9771 10.1507C12.2367 10.1507 11.6362 9.55018 11.6362 8.80988C11.6363 8.06959 12.2368 7.46907 12.9771 7.46906Z"
      stroke="white"
      stroke-opacity="0.4"
      stroke-width="0.3"
    />
    <path
      d="M12.2798 12.0114C12.0832 11.748 11.7102 11.6938 11.4467 11.8904C11.4353 11.8989 11.4243 11.9078 11.4135 11.9171C10.5717 12.5319 9.42903 12.5319 8.58726 11.9171C8.33855 11.7021 7.96265 11.7295 7.7477 11.9782C7.53271 12.2269 7.56009 12.6028 7.8088 12.8178C7.81954 12.8271 7.83064 12.836 7.84204 12.8445C9.11614 13.8183 10.8846 13.8183 12.1587 12.8445C12.4222 12.6479 12.4764 12.2749 12.2798 12.0114Z"
      fill="white"
      fill-opacity="0.4"
    />
    <path
      d="M11.3567 11.7702C11.6865 11.5241 12.1535 11.5919 12.3997 11.9216C12.6455 12.2509 12.5778 12.7161 12.2493 12.9626L12.2502 12.9636C10.9228 13.9782 9.07998 13.9786 7.7522 12.9645C7.73807 12.954 7.72379 12.9431 7.71021 12.9313C7.39917 12.6623 7.36526 12.1919 7.63403 11.8806C7.90046 11.5723 8.36463 11.5351 8.67603 11.7956L8.82642 11.8972C9.59721 12.3702 10.5856 12.336 11.3254 11.7956C11.3357 11.787 11.3459 11.7783 11.3567 11.7702Z"
      stroke="white"
      stroke-opacity="0.4"
      stroke-width="0.3"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "SmileIcon",
})
</script>

<style></style>
